module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmBAMAAABaE/SdAAAAHlBMVEWmoLBHcEynobCmoLCmoLCmoLCloLCmoLCnn7GmoLAtHIfPAAAACXRSTlP0AEU7KbBeamM82BcdAAAA5klEQVQoz4XSOw7CMAyAYSvhoY4OSDCmNwg3KDdgZYMbwE26MPi2JLZjZ0CiQ6X++qq2ruF4217Rj3YJC1EYWibawJ1onS2liegD9TTAymjlZjDxVbvXYWP13oUcMqvPOEwOma0XwGJQWERAh8pqM9hZawL3+FLWmkA9KuMmkDrjNsDGpBlkJs0gM21nbc+hoTb8007a3kPL2oK3ZO8yW8v2zqG3NHzbrC0PMwjShO3w0SH4eG3g4OO1gYMxNAjODOo/57kp3MhuRN2NIrsxOVMoexVt10rfK2MCea/isLulPePHjn8B+OHRuXVOJVoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/common/close.png
// module id = 208
// module chunks = 1